<template>
    <section class="full-height-vh bg-white">
        <div class="demo-grid mdc-layout-grid">
            <div class="mdc-layout-grid__inner">
                <!-- <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12 align-center login-logo">
                    <router-link to="/login">
                        <img :src="brandLogo" alt="">
                    </router-link>
                    
                </div> -->
                <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12 align-center">
                    <span class="t-headline3">
                        {{$t('1519')}}
                        <!-- 회원가입 -->
                    </span>
                </div>
               
                <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12">
                    
                    <div class="t-body3 t-color-content1 align-center mt30">
                        {{$t('1520')}}<br>
                        {{$t('1521')}}
                        <!-- 하나의 계정으로 서비스를 이용하세요.<br>
                        소셜 계정으로 이용하거나<br>
                        이메일 계정을 만들 수 있습니다.<br> -->
                    </div>

                    <div class="mt40 mb40 align-center">
                        <button class="mdc-button btn-sns-sign" @click.prevent="socialLoginAuth('google')">
                            <img src="https://aid-frontend.prod.atl-paas.net/atlassian-id/front-end/2.6.51/static/media/google-logo.c21ca9d1.svg">
                        </button>
                        <button class="mdc-button btn-sns-sign" @click.prevent="socialLoginAuth('facebook')">
                            <img src="https://upload.wikimedia.org/wikipedia/commons/c/c2/F_icon.svg">
                        </button>
                    </div>
                    
                    <hr class="divider-text t-body4" :data-content="$t('1522')">

                    <div class="mt40">
                        <button class="mdc-button mdc-button--raised btn-red w-full btn-big" @click="createAcount">
                            {{$t('1523')}}
                            <!-- 계정 만들기 -->
                        </button>
                    </div>


                    <div class="t-body4 t-color-content12 mt30">
                        {{$t('1524')}}
                        <!-- 가입한 계정이 있나요?  -->
                        <router-link to="/login" class="t-color-red12">
                        {{$t('1525')}}
                        <!-- 로그인하기 -->
                        </router-link>
                    </div>

                </div>
            </div>
        </div>
    </section>
</template>

<script>
import {MDCRipple} from '@material/ripple'
import firebase from 'firebase'

import { mapState, mapMutations } from 'vuex'

import loginApi from '@/api/loginApi.js'
import joinApi from '@/api/joinApi.js'



export default {
    data() {
        return {
            socialType: '',
            socialToken: '',
            socialFirstName: '',
            socialLastName: '',
            socialFullName: '',
            socialEmail: '',
            brandLogo: localStorage.getItem('brandLogo'),
            
        }
    },
    created() {
        // firebase 초기화
        // firebase.initializeApp(firebaseConfig)
        firebase.auth().onAuthStateChanged(function(user) {
            if (user) {
                // User is signed in.
            } else {
                // No user is signed in.
            }
            console.log(user)
        
        });
    },

    computed : {
        ...mapState('join',{
            join : state => state,
        })
    },

    mounted() {
        this.INIT_JOIN_STORE()
    },

    methods: {
        // Store 변이 정의
        ...mapMutations('join', [
            'SET_SOCIAL_LINK', 'SET_NAME_FIRST', 'SET_NAME_LAST', 'SET_NAME_FULL', 'SET_LOGINID', 'SET_SOCIAL_ID', 'INIT_JOIN_STORE'
        ]),

        socialLoginAuth(socialType){
            let provider = null
            this.socialType = socialType

            if (socialType === 'google') {
                provider = new firebase.auth.GoogleAuthProvider()
            }else if (socialType === 'facebook') {
                provider = new firebase.auth.FacebookAuthProvider()
            }

            
            
            firebase.auth().signInWithPopup(provider).then((result) => {

                console.log('socialType');
                let providerUserInfo = null
                providerUserInfo = result.additionalUserInfo.profile
                console.log('providerUserInfo',providerUserInfo)
                
                if (socialType === 'google') {
                    this.socialFirstName =  providerUserInfo.family_name
                    this.socialLastName = providerUserInfo.given_name
                    this.socialFullName = providerUserInfo.name
                    this.socialEmail = providerUserInfo.email
                }else if (socialType === 'facebook') {
                    this.socialFirstName =  providerUserInfo.first_name
                    this.socialLastName = providerUserInfo.last_name
                    this.socialFullName = providerUserInfo.name
                    this.socialEmail = providerUserInfo.email
                }

                
                firebase.auth().currentUser.getIdToken(true).then((idToken) => {
                    console.log('socialToken',idToken);
                    this.socialToken = idToken
                    
                    let params = {
                        type: 'firebase',
                        token: this.socialToken
                    }

                    joinApi.existsSocial(params).then((response) => {
                        console.log('existsSocial', response.data.data);
                        if (response.data.data) { 
                            this.$router.push({name: 'JoinExistSocial'})
                        }else {
                            console.log('회원가입하자')
                            this.SET_NAME_FIRST(this.socialFirstName)
                            this.SET_NAME_LAST(this.socialLastName)
                            this.SET_NAME_FULL(this.socialFullName)
                            
                            this.SET_SOCIAL_LINK({
                                type: 'firebase',
                                token: this.socialToken
                            })
                            this.SET_SOCIAL_ID(this.socialEmail)
                            this.SET_LOGINID(this.socialEmail)
                            this.$router.push({name: 'JoinRole', query: {
                                type: 'social'
                            }})
                        }
                        
                        

                    }).catch((err) => {
                        // console.log('회원가입 진행')
                        // this.$router.push({name: 'JoinExistSocial'})
                        // responseData = err.response.data.meta
                    })
                }).catch(function(error) {

                    console.log('error', error);
                    
                })
                
            }).catch(function(err) {
               console.log('error', err);

               if (err.email && err.credential && err.code === 'auth/account-exists-with-different-credential') {
                const providers = firebase.auth().fetchSignInMethodsForEmail(err.email)
                const firstPopupProviderMethod = providers.find(p => supportedPopupSignInMethods.includes(p));

                // Test: Could this happen with email link then trying social provider?
                if (!firstPopupProviderMethod) {
                    throw new Error(`Your account is linked to a provider that isn't supported.`);
                }

                const linkedProvider = getProvider(firstPopupProviderMethod);
                linkedProvider.setCustomParameters({ login_hint: err.email });

                const result = firebase.auth().signInWithPopup(linkedProvider);
                result.user.linkWithCredential(err.credential);
                }

            })
        },

        createAcount() {
            this.$router.push({name: 'JoinRole'})
        },


        // 로그인 API 파라미터 설정
        setParams(loginType) {
            let params = null

            
            params = {
                userId: '',
                password: '',
                device: {
                    type: 'WEB'
                },
                social: {
                    type: this.socialType,
                    token: this.socialToken
                }
            }
        
            return params
        },

        callLoginApi(loginType) {
            let params = this.setParams(loginType)
            loginApi.login(params).then((response) => {
                this.$route.push({name: JoinExistSocial})

            }).catch((err) => {
                console.log('회원가입 진행')
                this.$router.push({name: 'JoinExistSocial'})
                
                // const responseData = err.response.data.meta
                // if (loginType === 'social') {
                //     this.$confirm({title:'잘못된 로그인 정보' ,content: '소셜로 가입된 계정이 없습니다. 회원가입 하시겠습니까?'}).then(() => {
                //         this.signOutFirebase()
                //         this.$router.push('/join/intro')
                //     }).catch(() => {
                //         this.signOutFirebase()
                //     })
                // }else {
                //     this.$snackOpen({contents:'올바르지 않은 로그인 정보입니다. 로그인 정보를 확인하고 다시 시도하세요.'}).then(() => {})
                // }
            })
        },

    }
}
</script>

<style>

</style>
